import DateUtils from '../../utils/DateUtils';
import { ReactComponent as AsteriskIcon } from '../../icons/asterisk.svg';
import { ReactComponent as CrossIcon } from '../../icons/cross.svg';
import React, {useContext } from 'react';
import SettingsContext from "../../context/settings/context";

type TProps = {
    dateOfBirth?: Date;
    dateOfDeath?: Date;
};

const LifeDates = ({ dateOfBirth, dateOfDeath }: TProps) => {
    const context = useContext(SettingsContext);
    const dottedDateOfBirth = dateOfBirth ? DateUtils.getDottedDate(dateOfBirth) : null;
    const dottedDateOfDeath = dateOfDeath ? DateUtils.getDottedDate(dateOfDeath) : null;

    return (
        <div className="cr-flex cr-gap cr-text-secondary">
            {dottedDateOfBirth && (
                <span className={'cr-dob'}>
                    { context.birthIcon ? (
                        <img
                            src={context.birthIcon}
                            alt="Birth Icon"
                            style={{ width: 16, height: 16, verticalAlign: 'middle', aspectRatio: '1/1' }}
                        />

                    ) : (
                        <AsteriskIcon />
                    )}{' '}
                    {dottedDateOfBirth}
                </span>
            )}
            {dottedDateOfDeath && (
                <span className={'cr-dod'}>
                    { context.deathIcon ? (
                        <img
                            src={context.deathIcon}
                            alt="Death Icon"
                            style={{ width: 16, height: 16, verticalAlign: 'middle', aspectRatio: '1/1' }}
                        />
                    ) : (
                        <CrossIcon />
                    )}{' '}
                    {dottedDateOfDeath}
                </span>
            )}
        </div>
    );
};

export default LifeDates;
